/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/VINScannerTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { TextPatternScannerResult } from '../text_pattern/TextPatternScannerTypes';
/** @hidden */
export const VinBarcodeExtractionStatusValues = [
    'SUCCESS',
    'BARCODE_WITHOUT_VIN',
    'NO_BARCODE_FOUND',
    'BARCODE_EXTRACTION_DISABLED',
];
/**
Result of the barcode scanner.
*/
export class VinBarcodeResult {
    /** @param source {@displayType `DeepPartial<VinBarcodeResult>`} */
    constructor(source = {}) {
        if (source.extractedVIN !== undefined) {
            this.extractedVIN = source.extractedVIN;
        }
        else {
            throw new Error('extractedVIN must be present in constructor argument');
        }
        if (source.rectangle !== undefined) {
            this.rectangle = source.rectangle.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('rectangle must be present in constructor argument');
        }
        if (source.status !== undefined) {
            this.status = source.status;
        }
        else {
            throw new Error('status must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            extractedVIN: this.extractedVIN,
            rectangle: this.rectangle.map((it) => {
                return it;
            }),
            status: this.status,
        };
    }
}
/**
Result of the VIN scanner.
*/
export class VinScannerResult {
    /** @param source {@displayType `DeepPartial<VinScannerResult>`} */
    constructor(source = {}) {
        if (source.textResult !== undefined) {
            this.textResult = new TextPatternScannerResult(source.textResult);
        }
        else {
            throw new Error('textResult must be present in constructor argument');
        }
        if (source.barcodeResult !== undefined) {
            this.barcodeResult = new VinBarcodeResult(source.barcodeResult);
        }
        else {
            throw new Error('barcodeResult must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            textResult: this.textResult.serialize(config),
            barcodeResult: this.barcodeResult.serialize(config),
        };
    }
}
/**
Configuration for the VIN scanner.
*/
export class VinScannerConfiguration {
    /** @param source {@displayType `DeepPartial<VinScannerConfiguration>`} */
    constructor(source = {}) {
        /**
          Optimize for scanning a single line or a single word. Enable this option when scanning a single line or single word that are hard to scan reliably.
          
          Default is true
          */
        this.optimizeSingleLine = true;
        /**
          If true, the VIN scanner will also extract VINs from barcodes.
          Requires a license that allows barcode scanning in addition to VIN scanning.
          
          Default is false
          */
        this.extractVINFromBarcode = false;
        /**
          Maximum image size (height or width) for OCR process. 0 - do not rescale.
          
          Default is 0
          */
        this.ocrResolutionLimit = 0;
        /**
          Maximum number of accumulated frames to inspect before actual result is returned.
          
          Default is 3
          */
        this.maximumNumberOfAccumulatedFrames = 3;
        /**
          Minimum number of accumulated frames that have equal result.
          
          Default is 2
          */
        this.minimumNumberOfRequiredFramesWithEqualScanningResult = 2;
        if (source.optimizeSingleLine !== undefined) {
            this.optimizeSingleLine = source.optimizeSingleLine;
        }
        if (source.extractVINFromBarcode !== undefined) {
            this.extractVINFromBarcode = source.extractVINFromBarcode;
        }
        if (source.ocrResolutionLimit !== undefined) {
            this.ocrResolutionLimit = source.ocrResolutionLimit;
        }
        if (source.maximumNumberOfAccumulatedFrames !== undefined) {
            this.maximumNumberOfAccumulatedFrames = source.maximumNumberOfAccumulatedFrames;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualScanningResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualScanningResult =
                source.minimumNumberOfRequiredFramesWithEqualScanningResult;
        }
    }
}
//# sourceMappingURL=VinScannerTypes.js.map